import {
  ChannelCommonServer,
  CommonChannelKind,
  IChannelBase,
  ICommonChannelModel,
  normalizeBaseChannel
} from 'shared/entities/channels';
import { IRootStore } from 'shared/entities/store/rootStore';
import ListModel from 'shared/models/ListModel';
import { FieldModel } from 'shared/models/form';

import ChannelTokenModel from './ChannelTokenModel';
import ChannelBaseModel from './ChannelBaseModel';

export default class CommonChannelModel
  extends ChannelBaseModel
  implements ICommonChannelModel
{
  readonly kind: CommonChannelKind;
  constructor({
    kind,
    ...params
  }: Omit<IChannelBase, 'tokens' | 'scenarioIds'> & {
    rootStore: IRootStore;
    tokens: ListModel<ChannelTokenModel>;
    scenarioIds: FieldModel<string[]>;
    kind: CommonChannelKind;
  }) {
    super(params);

    this.kind = kind;
  }

  static fromJson(
    raw: ChannelCommonServer,
    rootStore: IRootStore
  ): CommonChannelModel {
    const collection = this.getCollectionTokens(raw, rootStore);

    return new CommonChannelModel({
      ...normalizeBaseChannel(raw),
      linked: raw.manager_linked,
      kind: raw.kind,
      tokens: new ListModel<ChannelTokenModel>(collection),
      scenarioIds: new FieldModel<string[]>(raw.scenario_ids),
      rootStore
    });
  }
}
